
import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Lazy load components with correct default imports
const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const ManifestationsPage = lazy(() => import('../pages/manifestations/page'));
const CommunitiesPage = lazy(() => import('../pages/communities/page'));
const AnalyticsPage = lazy(() => import('../pages/analytics/page'));
const MonitoringPage = lazy(() => import('../pages/monitoring/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const ChatbotPage = lazy(() => import('../pages/chatbot/page'));
const SystemsPage = lazy(() => import('../pages/systems/page').then(module => ({ default: module.SystemsControl })));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center">
    <div className="text-center">
      <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
        <i className="ri-robot-line text-white text-2xl"></i>
      </div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">Agente Autônomo</h1>
      <p className="text-gray-600 mb-6">Relacionamento com Comunidades</p>
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-600"></div>
        <span className="ml-3 text-gray-600">Carregando...</span>
      </div>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <HomePage />
      </Suspense>
    )
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <LoginPage />
      </Suspense>
    )
  },
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <DashboardPage />
      </Suspense>
    )
  },
  {
    path: '/manifestations',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ManifestationsPage />
      </Suspense>
    )
  },
  {
    path: '/manifestations/:id',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ManifestationsPage />
      </Suspense>
    )
  },
  {
    path: '/communities',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <CommunitiesPage />
      </Suspense>
    )
  },
  {
    path: '/analytics',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <AnalyticsPage />
      </Suspense>
    )
  },
  {
    path: '/monitoring',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <MonitoringPage />
      </Suspense>
    )
  },
  {
    path: '/reports',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ReportsPage />
      </Suspense>
    )
  },
  {
    path: '/settings',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SettingsPage />
      </Suspense>
    )
  },
  {
    path: '/chatbot',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <ChatbotPage />
      </Suspense>
    )
  },
  {
    path: '/systems',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <SystemsPage />
      </Suspense>
    )
  },
  {
    path: '/multiagent',
    element: lazy(() => import('../pages/multiagent/page'))
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        <NotFoundPage />
      </Suspense>
    )
  }
];

export default routes;
